import { FC } from 'react';
import { observer } from 'mobx-react-lite';
import { Box, IconButton, Modal } from '@mui/material';
import CloseIcon from '@mui/icons-material/CloseOutlined';
import 'react-image-gallery/styles/css/image-gallery.css';
import ImageGallery from 'react-image-gallery';

import step_0 from '../../assets/tutorial/Step_0.png';
import step_1 from '../../assets/tutorial/Step_1.png';
import step_2 from '../../assets/tutorial/Step_2.png';
import step_3 from '../../assets/tutorial/Step_3.png';
import step_4 from '../../assets/tutorial/Step_4.png';
import step_5 from '../../assets/tutorial/Step_5.png';
import step_6 from '../../assets/tutorial/Step_6.png';
import step_7 from '../../assets/tutorial/Step_7.png';
import step_8 from '../../assets/tutorial/Step_8.png';
import step_9 from '../../assets/tutorial/Step_9.png';
import step_10 from '../../assets/tutorial/Step_10.png';

interface Props {
  open: boolean;
  handleClose: () => void;
  step?: number;
}

const TutorialModal: FC<Props> = observer(props => {
  const { open, handleClose, step } = props;

  const images = [
    { original: step_0, thumbnail: step_0 },
    { original: step_1, thumbnail: step_1 },
    { original: step_2, thumbnail: step_2 },
    { original: step_3, thumbnail: step_3 },
    { original: step_4, thumbnail: step_4 },
    { original: step_5, thumbnail: step_5 },
    { original: step_6, thumbnail: step_6 },
    { original: step_7, thumbnail: step_7 },
    { original: step_8, thumbnail: step_8 },
    { original: step_9, thumbnail: step_9 },
    { original: step_10, thumbnail: step_10 },
  ];
  return (
    <Modal open={open} onClose={handleClose}>
      {step ? (
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            bgcolor: 'background.paper',
            border: '2px solid #000',
            boxShadow: 24,
            p: 4,
            display: 'flex',
            alignItems: 'center',
          }}
        >
          <img src={images[step].original} width="90%" alt="Tutorial-Images" />
          <IconButton
            sx={{ position: 'absolute', right: 5, top: 5 }}
            color="primary"
            component="span"
            onClick={handleClose}
          >
            <CloseIcon />
          </IconButton>
        </Box>
      ) : (
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            bgcolor: 'background.paper',
            border: '2px solid #000',
            boxShadow: 24,
            p: 4,
            display: 'flex',
            alignItems: 'center',
          }}
        >
          <ImageGallery items={images} />
          <IconButton
            sx={{ position: 'absolute', right: 5, top: 5 }}
            color="primary"
            component="span"
            onClick={handleClose}
          >
            <CloseIcon />
          </IconButton>
        </Box>
      )}
    </Modal>
  );
});

export default TutorialModal;
